import { GlobalAxios } from "../axios/axios-config";
import { IInsurancePlan } from "../models/insurance-plan";

const INSURANCE_PLAN_ROUTE =
  process.env.REACT_APP_EXTERNAL + "/api/v1/InsurancePlan/InsurancePlan";

export const insurancePlanList = (params?: any) => {
  return GlobalAxios.get<IInsurancePlan[]>(INSURANCE_PLAN_ROUTE, {
    params: params,
    paramsSerializer: { indexes: null },
  });
};
